// Next.js inlines only static `process.env.NEXT_PUBLIC_*` member accesses into the browser bundle; never alias or spread `process.env` here.
export const clientObservabilityEnv: NodeJS.ProcessEnv = {
  NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
  NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
  NODE_ENV: process.env.NODE_ENV,
};

const PRODUCTION_HOSTS = new Set([
  "membentry.com",
  "www.membentry.com",
  "app.membentry.com",
]);

// WHY: staging and production web images are both built with NODE_ENV=production, so the build cannot tell them apart.
export function clientSentryEnvironment(hostname: string): string {
  if (PRODUCTION_HOSTS.has(hostname)) return "production";
  if (hostname === "staging.membentry.com") return "staging";
  return "development";
}
